<template>
    <!-- 顶部 -->
    <div class="header">
        <div class="bs-docs-nav">
            <div class="container-fluid">
                <div class="navbar-header">
                    <div class="header-content">
                        <!-- 顶部左边图片 -->
                        <a href="/" class="logo-img">
                            <img src="../../assets/img/logo.jpg" alt="">
                        </a>
                        <div class="header-top-nav">
                            <!-- 语言切换 -->
                            <div class="search-language">
                                <div class="search-language-box">
                                    <span class="language-font zh" :class="{ 'language-click': language == 'zh' }"
                                        @click="switchLanguage">中文</span>
                                    <div class="line"></div>
                                    <span class="language-font en" :class="{ 'language-click': language == 'en' }"
                                        @click="switchLanguage">EN</span>
                                </div>
                            </div>
                            <!-- 搜索 -->
                            <a class="search" @click="showAD">
                                <img src="../../assets/img/search-img.png" alt="">
                            </a>
                            <!-- 折叠 -->
                            <div class="navbar-toggle btn-nav" :class="[drawer ? 'animated' : 'collapsed']"
                                @click="drawerClick">
                                <span class="icon-bar tops"></span>
                                <span class="icon-bar middle"></span>
                                <span class="icon-bar bottom"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="bs-navbar" class="navbar-collapse collapse" :class="{ 'in': drawer }">

                    <!-- <div v-for="(item,index) in menuList" class="top-menu-small-item" :key="item.id">
                        <div @click="goToHref(item,true)" :class="{'dropdown-item-active': item.name == clickMenuName}">{{ item.name }}</div> 
                        <span v-show="item.child" style="font-size:2rem;float:right" @click="changeChildShow">
                            <i :class="!showChild?'el-icon-arrow-right':'el-icon-arrow-down'" style="position: relative;top:-2rem"></i> 
                        </span>
                        <div v-if="item.child&&showChild" style="width: 96%;padding: 2rem 0;">
                            <div class="top-menu-small-item" :class="{'dropdown-item-active': childItem.href == clickMenuUrl}" v-for="(childItem,childIndex) in item.child" @click="goToHref(childItem,true)" :key="childItem.id">
                            {{ childItem.name }}
                            <el-divider v-if="childIndex < item.child.length - 1"></el-divider>
                            </div>
                        </div>
                        <el-divider v-if="index < menuList.length - 1"></el-divider>
                    </div> -->

                    <ul class="nav navbar-nav">
                        <li v-for="item in menuList" :key="item.id">
                            <a @click="goToHref(item,true)" class="act_cmenu" :class="{'down-arrow' : item.child}">{{ item.name }}</a>
                        </li>
                        <!-- <li>
                            <a @click="$router.push('/news')" class="act_cmenu">{{ $t('News') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push('/organizationalProfile/foundationIntroduction')" class="down-arrow">{{ $t('OrganizationalProfile') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push('/foundationProject')" class="act_cmenu">{{ $t('FoundationProject') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push('/specialFund')" class="act_cmenu">{{ $t('SpecialFund') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push('/kidsGallery')" class="act_cmenu">{{ $t('KidsGallery') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push('/toDownload')" class="act_cmenu">{{ $t('Download') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push('/contactUs')" class="act_cmenu">{{ $t('ContactUs') }}</a>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>

        <div class="top-menu-small-bottom" v-if="isShowAD">
            <div>
                <div style="width: 100%;height:4rem">
                    <el-input suffix-icon="el-icon-search" v-model="searchInput" :placeholder="$t('PleaseInput')" @keyup.enter.native="goToSearch" style="width: 90%;margin:auto 5%"></el-input>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                drawer: false,
                isShowAD: false,
                searchInput: '',
                language: localStorage.getItem('locale') || 'zh',
            }
        },
        computed: {
            menuList() {
                return [
                    {
                    name: this.$t('Home'),
                    id: '1',
                    href: '/',
                    hrefList: [
                        '/',
                    ]
                    },
                    {
                    name: this.$t('News'),
                    id: '2',
                    href: '/news',
                    hrefList: [
                        '/news',
                        '/newsDetails',
                    ]
                    },
                    {
                    name: this.$t('OrganizationalProfile'),
                    id: '3',
                    href: '/organizationalProfile/foundationIntroduction',
                    hrefList: [
                        '/organizationalProfile/foundationIntroduction',
                        '/organizationalProfile/foundingDirectorUnit',
                        '/organizationalProfile/organizationStructure',
                        '/organizationalProfile/council',
                    ],
                    child: [
                        {
                        name: this.$t('FoundationIntroduction'),
                        id: '31',
                        href: '/organizationalProfile/foundationIntroduction'
                        },
                        {
                        name: this.$t('FoundingDirectorUnit'),
                        id: '32',
                        href: '/organizationalProfile/foundingDirectorUnit'
                        },
                        {
                        name: this.$t('Council'),
                        id: '33',
                        href: '/organizationalProfile/council'
                        },
                        {
                        name: this.$t('OrganizationStructure'),
                        id: '34',
                        href: '/organizationalProfile/organizationStructure'
                        }
                    ]
                    },
                    {
                    name: this.$t('FoundationProject'),
                    id: '4',
                    href: '/foundationProject',
                    hrefList: [
                        '/foundationProject',
                        '/foundationProjectDetails',
                    ]
                    },
                    {
                    name: this.$t('SpecialFund'),
                    id: '5',
                    href: '/specialFund',
                    hrefList: [
                        '/specialFund',
                        '/specialFundDetails',
                        '/specialFundNewsDetails',
                    ]
                    },
                    {
                    name: this.$t('Download'),
                    id: '7',
                    href: '/toDownload',
                    hrefList: [
                        '/toDownload',
                    ]
                    },
                    {
                    name: this.$t('ContactUs'),
                    id: '8',
                    href: '/contactUs',
                    hrefList: [
                        '/contactUs',
                    ]
                    }

                ];
            }
        },
        methods: {
            goToHref(item, type) {
            // console.log('item', item);

                this.$router.push(item.href);
                if (type) {
                    this.drawer = !this.drawer
                }
            },
            showAD() {
                this.isShowAD = !this.isShowAD;
            },
            goToSearch() {
                if (this.searchInput) {
                    this.$router.push({ path: '/news', query: { search: this.searchInput } });
                    this.isShowAD = !this.isShowAD
                }
            },
            // 抽屉
            drawerClick() {
                this.drawer = !this.drawer;
            },
            // 语言切换
            switchLanguage() {
                this.language = this.language === 'zh' ? 'en' : 'zh';
                // 此处做了语言选择记录，存在localStorage中，这里的作用只有一个当我重新请求页面
                //的时候先取localStorage的记录值
                localStorage.setItem('locale', this.language)
                this.$i18n.locale = this.language; // 修改页面需要显示的语言
                location.reload();
            }
        }
    }
</script>

<style lang="less" scoped>
.header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1001;
}
.top-menu-small-bottom {
  width: 100%;
  background: #ffff;
  z-index: 9999;
  position: absolute;
  top: 5rem;
  padding: 2rem 0;
}
.container-fluid {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
    padding-right: 0px;
    padding-left: 0px;
    margin-right: auto;
    margin-left: auto;
}

.navbar-header {
    width: 100%;
    margin-left: 0px;
}

.header-content {
    padding: 7px 12px 7px 10px;
    // line-height: 54px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.navbar-toggle {
    position: relative;
    left: 0px;
    transition: all .5s ease;
}

.icon-bar {
    transition: all .7s ease
}

.navbar-toggle .icon-bar {
    background: #9e9ea7;
    margin: unset !important;
    background-color: #BA000E;
    height: 2px;
    width: 24px;
    display: block;
    border-radius: 1px;
}

.navbar-toggle .middle {
    margin: 8px 0 !important;
}

.navbar-toggle:focus {
    outline: 0;
}


.animated {
    display: block;
}

.animated:focus {
    cursor: pointer;
    z-index: 9999;
}

.animated .tops {
    transform: translateY(11px) rotateZ(45deg);
}

.animated .middle {
    width: 0;
}

.animated .bottom {
    transform: translateY(-9px) rotateZ(-45deg);
}

#bs-navbar {
    background: #fff;
    width: 100%;
    height: 100vh;
    padding-bottom: 10px;
    border-radius: 0 0 0.5rem 0.5rem;
    box-shadow: 0px 300px 0px 300px rgb(0 0 0 / 50%);
    display: none;
}

.navbar-collapse {
    padding-right: 15px;
    padding-left: 15px;
    border-top: 1px solid transparent;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);
}

.navbar-nav {
    margin: 7.5px -15px;
}

.nav {
    padding-left: 0;
    list-style: none;
}

.nav>li {
    position: relative;
    display: block;
    list-style: none;
}

#bs-navbar .navbar-nav li .act_cmenu {
    font-weight: bolder;
    color: #000;
    width: 100%;
    padding: 10px 20px;
    line-height: 26px;
}

#bs-navbar .navbar-nav li a {
    font-size: 18px;
    width: 100%;
    padding: 10px 20px;
    /* font-size: 15px; */
    color: #BA000E;
    font-family: 'sourceHanSansCNRegular';
    text-decoration: none;
}
#bs-navbar .navbar-nav li+li {
    border-top: 1px solid #f8f8f8;
}
#bs-navbar .navbar-nav li .down-arrow {
    position: relative;
    padding: 10px 20px;
    font-size: 18px;
    color: #000;
    width: 100%;
    background: transparent;
    border: none;
    text-align: left;
    font-weight: bold;
    line-height: 26px;
}
.collapse{
    display: none;
}
.collapse.in {
    display: block;
}
.down-arrow::after{
    display: inline-block;
    content: " ";
    height: 10px;
    width: 10px;
    border-width: 2px 2px 0 0;
    border-color: #000;
    border-style: solid;
    transform: matrix(.71, .71, -.71, .71, 0, 0);
    transform-origin: center;
    transition: transform .3s;
    position: absolute;
    top: 50%;
    right: 100px;
    margin-top: -5px;
}
.down-arrow.act_in::after {
    transform-origin: center;
    transform: rotate(135deg);
    transition: transform .3s;
    top: 60%;
}

.navbar-nav>li>a {
    line-height: 20px;
}

.nav>li>a {
    position: relative;
    display: block;
}

#bs-navbar.in {
    display: block !important;
}

.header-top-nav {
    display: flex;
    align-items: center;

    .search {
        margin: 0 24px 0 22px;

        img {
            width: 20px;
            height: 20px;
        }
    }
}
.logo-img {
    // width: 140px;
    height: 46px;
}

.logo-img img {
    // width: 140px;
    height: 46px;
}
.search-language {
    .search-language-box {
        display: flex;
        align-items: center;

        .line {
            height: 15px;
            margin: 0px 10px 0px 12px;
            border-left: 1px solid #D8DCE6;
        }

        .language-font {
            font-size: 14px;
        }

        .language-click {
            font-weight: 800;
        }

        .search-div {
            float: left;
            width: 13rem;
            height: 3rem;
            background: #f7f8f9;
            border-radius: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;

            ::v-deep .el-input__inner {
                width: 60% !important;
                border: none;
                height: 2.5rem;
                outline: none;
                font-size: 1rem;
                padding: 0;
                margin-left: 1rem;
                background: #f7f8f9;
            }
        }
    }
}
</style>